import { Link } from '@tanstack/react-router';
import type { StravaStatus } from '@painpal/contracts';
import type { SessionUser } from '../auth/session';
import { BrandMark } from '../components/BrandMark';
import { NAV_ITEMS } from '../ui/navItems';
import { initials, syncPill } from './appBarModel';
import styles from './app.module.css';

export function AppBar({ user, strava }: { user: SessionUser; strava: StravaStatus | undefined }) {
  const pill = syncPill(strava, new Date());
  return (
    <header className={styles.bar}>
      <Link to="/" aria-label="PainPal home"><BrandMark /></Link>
      <nav className={styles.nav} aria-label="Main">
        {NAV_ITEMS.map((item) => (
          <Link key={item.to} to={item.to} className={styles.navLink} activeOptions={{ exact: item.exact }} activeProps={{ 'aria-current': 'page' }}>
            {item.label}
          </Link>
        ))}
      </nav>
      <div className={styles.right}>
        {pill !== null && (
          <span className={styles.pill} data-tone={pill.tone}>
            <span data-part="long" className="sr-only-phone">STRAVA · </span>{pill.text}
          </span>
        )}
        <Link to="/settings" className={styles.avatar} aria-label={`Account settings for ${user.name}`}>{initials(user.name)}</Link>
      </div>
    </header>
  );
}
